import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Create the context
const VendorContext = createContext();

// Custom hook for using vendor context
export const useVendor = () => useContext(VendorContext);

// Provider component
export const VendorProvider = ({ children }) => {
  const navigate = useNavigate();
  const [vendor, setVendor] = useState(() => {
    const saved = localStorage.getItem('vendor');
    return saved ? JSON.parse(saved) : null;
  });

  const [vendorAuthToken, setVendorAuthToken] = useState(() => {
    return localStorage.getItem('vendorAuthToken') || null;
  });

  // Sync with localStorage when updated elsewhere
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'vendor') {
        setVendor(e.newValue ? JSON.parse(e.newValue) : null);
      }
      if (e.key === 'vendorAuthToken') {
        setVendorAuthToken(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // 🔹 Update vendor and token
  const updateVendor = (newVendorInfo, token = null) => {
    const updatedVendor = { ...vendor, ...newVendorInfo };
    setVendor(updatedVendor);
    localStorage.setItem('vendor', JSON.stringify(updatedVendor));

    if (token) {
      setVendorAuthToken(token);
      localStorage.setItem('vendorAuthToken', token);
    }
  };

  // 🔹 Logout: clear everything
  const logout = () => {
    setVendor(null);
    setVendorAuthToken(null);
    localStorage.removeItem('vendor');
    localStorage.removeItem('vendorAuthToken');
    navigate('/login');
  };

  // 🔹 Getter for token
  const getJwtToken = () => vendorAuthToken;

  return (
    <VendorContext.Provider value={{ vendor, vendorAuthToken, updateVendor, getJwtToken, logout }}>
      {children}
    </VendorContext.Provider>
  );
};
